import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { GygStoresTagsType, GygTagsType } from 'src/types/apps/gygStoresTagsTypes'
import { Redux } from 'src/store'

type GygStoresTagsStateType = {
  gygStoreTags: GygStoresTagsType[]
  searchStoreTags: GygStoresTagsType[]
  gygTags: GygTagsType[]
  gygStoreTag: GygStoresTagsType | null
  gygTag: GygTagsType | null
  pending: boolean
  getStoreTagsPending: boolean
  updateStoreTagPending: boolean
  searchStoreTagsPending: boolean
  getTagsSearchPending: boolean
  getTagsPending: boolean
  errors: any // todo
}

interface GetStoreTagsListResponse {
  data: GygStoresTagsType[]
}
interface GetTagsListResponse {
  data: GygTagsType[]
}
interface GetTagListResponse {
  data: GygTagsType
}

const initialState: GygStoresTagsStateType = {
  gygStoreTags: [],
  searchStoreTags: [],
  gygTags: [],
  gygStoreTag: null,
  gygTag: null,
  errors: {},
  pending: false,
  getStoreTagsPending: false,
  updateStoreTagPending: false,
  searchStoreTagsPending: false,
  getTagsSearchPending: false,
  getTagsPending: false
}

export const getStoreTagsLists = createAsyncThunk<GetStoreTagsListResponse, void, Redux>(
  'gygStoreTagsList/gygStoreTags',
  async (_, { extra }) => {
    const response = await extra.httpClient(`store-tags?take=0&skip=0`)

    return response.data
  }
)

export const getStoreTagsSearch = createAsyncThunk<GetStoreTagsListResponse, string, Redux>(
  'gygStoreTagsList/gygStoreTagsSearch',
  async (storeId: string, { extra }) => {
    const response = await extra.httpClient(`store-tags?store=${storeId}`)

    return response.data
  }
)

export const getTagsSearch = createAsyncThunk<GetTagListResponse, string, Redux>(
  'gygStoreTagsList/getTagsSearch',
  async (tagId: string, { extra }) => {
    const response = await extra.httpClient(`tags/${tagId}`)

    return response.data
  }
)

export const getAllTags = createAsyncThunk<GetTagsListResponse, void, Redux>(
  'gygStoreTagsList/getAllTags',
  async (_, { extra }) => {
    const response = await extra.httpClient(`tags`)

    return response.data
  }
)

export const gygStoresTagsListed = createSlice({
  name: 'gygStoreTagsList',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder

      // All Store Tags get
      .addCase(getStoreTagsLists.fulfilled, (state, action) => {
        state.gygStoreTags = action.payload.data
        state.getStoreTagsPending = false
      })
      .addCase(getStoreTagsLists.pending, state => {
        state.getStoreTagsPending = true
      })
      .addCase(getStoreTagsLists.rejected, state => {
        state.getStoreTagsPending = false
      })

      // All Store Tags search by storeId
      .addCase(getStoreTagsSearch.fulfilled, (state, action) => {
        state.searchStoreTags = action.payload.data
        state.searchStoreTagsPending = false
      })
      .addCase(getStoreTagsSearch.pending, state => {
        state.searchStoreTagsPending = true
      })
      .addCase(getStoreTagsSearch.rejected, state => {
        state.searchStoreTagsPending = false
      })

      // All Store Tags search by storeId
      .addCase(getTagsSearch.fulfilled, (state, action) => {
        state.gygTag = action.payload.data
        state.getTagsSearchPending = false
      })
      .addCase(getTagsSearch.pending, state => {
        state.getTagsSearchPending = true
      })
      .addCase(getTagsSearch.rejected, state => {
        state.getTagsSearchPending = false
      })

      // All Store Tags search by storeId
      .addCase(getAllTags.fulfilled, (state, action) => {
        state.gygTags = action.payload.data
        state.getTagsPending = false
      })
      .addCase(getAllTags.pending, state => {
        state.getTagsPending = true
      })
      .addCase(getAllTags.rejected, state => {
        state.getTagsPending = false
      })
  }
})

export default gygStoresTagsListed.reducer
